// components/SignupModal.js
import React, { useState } from "react";
import {
  Modal,
  ModalHeader,
  ModalBody,
  Button,
  Form,
  Input,
  FormGroup,
  Label,
  Spinner,
} from "reactstrap";
import axios from "axios";

const SignupModal = ({ isOpen, toggle }) => {
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState({
    id: "",
    password: "",
    userName: "",
    mobileNo: "",
    emailId: "",
    address: "",
    dob: "",
    rights: "Subscriber",
    location: "",
    createdBy: "",
  });

  const handleChange = (e) => {
    setFormData((prev) => ({
      ...prev,
      [e.target.name]: e.target.value,
    }));
  };
  function cleanMobileNumber(mobileNo) {
    return mobileNo.replace(/^(\+91|91)/, "").trim();
  }

  const handleSignup = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_COLLEGE_ERP_API}signup`,
        { ...formData, mobileNo: cleanMobileNumber(formData.mobileNo) },
        {
          params: {
            branch: "Kyts",
          },
        }
      );
      alert("Signup successful!");
      toggle();
    } catch (err) {
      console.error(err);
      alert(err?.response?.data?.message || "Signup failed.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal isOpen={isOpen} toggle={toggle}>
      <ModalHeader toggle={toggle}>Create New Account</ModalHeader>
      <ModalBody>
        <Form onSubmit={handleSignup}>
          <FormGroup>
            <Label for="id">User ID</Label>
            <Input
              name="id"
              value={formData.id}
              onChange={handleChange}
              required
            />
          </FormGroup>
          <FormGroup>
            <Label for="password">Password</Label>
            <Input
              type="password"
              name="password"
              value={formData.password}
              onChange={handleChange}
              required
            />
          </FormGroup>
          <FormGroup>
            <Label for="userName">Name</Label>
            <Input
              name="userName"
              value={formData.userName}
              onChange={handleChange}
            />
          </FormGroup>
          <FormGroup>
            <Label for="mobileNo">Mobile No</Label>
            <Input
              name="mobileNo"
              value={formData.mobileNo}
              onChange={handleChange}
            />
          </FormGroup>
          <FormGroup>
            <Label for="emailId">Email</Label>
            <Input
              name="emailId"
              type="email"
              value={formData.emailId}
              onChange={handleChange}
            />
          </FormGroup>
          <FormGroup>
            <Label for="address">Address</Label>
            <Input
              name="address"
              value={formData.address}
              onChange={handleChange}
            />
          </FormGroup>
          <FormGroup>
            <Label for="dob">DOB</Label>
            <Input
              type="date"
              name="dob"
              value={formData.dob}
              onChange={handleChange}
            />
          </FormGroup>
          <FormGroup>
            <Label for="location">Location</Label>
            <Input
              name="location"
              value={formData.location}
              onChange={handleChange}
            />
          </FormGroup>
        { 
         // <FormGroup>
         //    <Label for="createdBy">Created By</Label>
         //    <Input
         //      name="createdBy"
         //      value={formData.createdBy}
         //      onChange={handleChange}
         //    />
         //  </FormGroup>
          }

          <Button
            type="submit"
            color="primary"
            disabled={loading}
            className="w-100 mt-2"
          >
            {loading ? <Spinner size="sm" /> : "Register"}
          </Button>
        </Form>
      </ModalBody>
    </Modal>
  );
};

export default SignupModal;
